import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/PaymentReports.css";

function PaymentReports() {

  const [payments, setPayments] = useState([]);

  // ================= LOAD PAYMENTS =================

  const loadPayments = async () => {

    try {

      const response = await axios.get(
        "http://localhost:8080/api/payments"
      );

      setPayments(response.data);

    } catch (error) {

      console.error("Error loading payments:", error);

      alert("Failed to load payment reports.");

    }

  };

  useEffect(() => {

    loadPayments();

  }, []);

  // ================= TOTAL AMOUNT =================

  const totalAmount = payments.reduce(
    (total, payment) =>
      total + Number(payment.amount || 0),
    0
  );

  return (

    <div className="payment-reports-page">

      <h2>💰 Payment Reports</h2>

      {/* ================= SUMMARY ================= */}

      <div className="payment-summary">

        <div className="payment-summary-box">

          <h3>{payments.length}</h3>

          <p>Total Payments</p>

        </div>

        <div className="payment-summary-box">

          <h3>₹{totalAmount.toFixed(2)}</h3>

          <p>Total Amount</p>

        </div>

      </div>

      {/* ================= PAYMENT TABLE ================= */}

      <div className="payment-table-container">

        <table className="payment-table">

          <thead>

            <tr>

              <th>S.No</th>
              <th>Date</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Purpose</th>
              <th>Amount</th>
              <th>Payment ID</th>
              <th>Status</th>

            </tr>

          </thead>

          <tbody>

            {payments.length === 0 ? (

              <tr>

                <td
                  colSpan="9"
                  className="no-payments"
                >
                  No payment records found
                </td>

              </tr>

            ) : (

              payments.map((payment, index) => (

                <tr key={payment.id}>

                  <td>{index + 1}</td>

                  <td>
                    {payment.paymentDate
                      ? new Date(
                          payment.paymentDate
                        ).toLocaleString()
                      : "-"}
                  </td>

                  <td>{payment.donorName}</td>

                  <td>{payment.phone || "-"}</td>

                  <td>{payment.email || "-"}</td>

                  <td>{payment.purpose || "-"}</td>

                  <td>
                    ₹{Number(
                      payment.amount || 0
                    ).toFixed(2)}
                  </td>

                  <td>
                    {payment.paymentId || "-"}
                  </td>

                  <td>

                    <span
                      className={
                        payment.paymentStatus === "SUCCESS"
                          ? "payment-success"
                          : "payment-failed"
                      }
                    >
                      {payment.paymentStatus || "-"}
                    </span>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );

}

export default PaymentReports;